import React from 'react';
import { ErrorMessageTemplate } from './error-handler-template';
import { MessengerLauncherWrapper } from 'works/legacy/components/messenger-launcher-wrapper';

export const StandardNotFoundErrorMessage = () => (
  <ErrorMessageTemplate
    title="Now, where did that page go?.."
    imageName="error-empty-list"
    imageAlt="Empty document with a magnifier icon meaning nothing was found."
  >
    <>
      We couldn&apos;t find what you were looking for.
      <br />
      Please try again, try a different account, or{' '}
      <MessengerLauncherWrapper>chat with support</MessengerLauncherWrapper> for
      further assistance.
    </>
  </ErrorMessageTemplate>
);

export const ContextualNotFoundErrorMessage = () => (
  <p>Not found, please try again.</p>
);

export const NotificationNotFoundErrorMessage = () => (
  <p>
    <strong>We couldn&apos;t find what you were looking for.</strong> Please try
    again, try a different account, or{' '}
    <MessengerLauncherWrapper>chat with support</MessengerLauncherWrapper> for
    further assistance.
  </p>
);
